import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "className", "title", "onHide", "headerLeft", "onLeftClick", "headerRight", "onRightClick", "onMaskClick", "hasClose"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-13 16:05:45
 * @LastEditTime: 2021-05-13 18:51:26
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import { Popup, Icon } from 'zarm';
import cn from 'classnames';
import Header from '../Header';
import './index.less';
export default function CPopup(props) {
  const {
    children,
    className,
    title,
    onHide,
    headerLeft,
    onLeftClick = onHide === null || onHide === void 0 ? void 0 : onHide(),
    headerRight,
    onRightClick = onHide === null || onHide === void 0 ? void 0 : onHide(),
    onMaskClick = onHide === null || onHide === void 0 ? void 0 : onHide(),
    hasClose
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  let right = headerRight;

  if (hasClose) {
    right = /*#__PURE__*/React.createElement(Icon, {
      type: "wrong"
    });
  }

  const cls = cn('cc-popup', {
    'cc-popup--close': hasClose
  }, className);
  return /*#__PURE__*/React.createElement(Popup, _extends({
    className: cls,
    onMaskClick: onMaskClick
  }, rest), /*#__PURE__*/React.createElement(Header, {
    headerLeft: headerLeft,
    title: title,
    headerRight: right,
    onLeftClick: onLeftClick,
    onRightClick: onRightClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "cc-popup__body"
  }, children));
}